import { render, staticRenderFns } from "./DadosMotorista.vue?vue&type=template&id=5f3aa344"
import script from "./DadosMotorista.vue?vue&type=script&lang=js"
export * from "./DadosMotorista.vue?vue&type=script&lang=js"
import style0 from "./DadosMotorista.vue?vue&type=style&index=0&id=5f3aa344&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports